
export interface AdminAccountCancelSubscriptionRequest {
  /** @nullable */
  reason?: string | null;
  subscriptionId: number;
  userId: string;
}
